import type { TranslationTag } from '@ps/web-shared-components';

import type { UnsuccessfulCashoutBetResponse } from '../types';

import {
  TXTWCL_Cash_Out_Unsuccessful,
  TXTWCL_Cash_Out_currently_unavailable_ELL,
  TXTWCL_Cash_Out_value_has_changedX_pl_ELL,
  TXTWCL_One_of_the_markets_in_your_bet_ELL,
  TXTWCL_Something_is_happening_with_yo_ELL,
  TXTWCL_SorryX_something_went_wrongX_P_ELL,
  TXTWCL_The_handicap_line_has_changedX_ELL,
  TXTWCL_This_bet_has_already_been_Cash_ELL,
  TXTWCL_This_bet_has_already_been_sett_ELL
} from './getTranslationForResponseStatus.messages.json';

const responseStatusToTranslationMap: Record<
  UnsuccessfulCashoutBetResponse['respStatus'],
  TranslationTag
> = {
  QUOTE_UNAVAILABLE: TXTWCL_Cash_Out_currently_unavailable_ELL,
  BET_CLOSED: TXTWCL_This_bet_has_already_been_sett_ELL,
  NOT_ELIGIBLE: TXTWCL_Cash_Out_Unsuccessful,
  INVALID_QUOTE: TXTWCL_SorryX_something_went_wrongX_P_ELL,
  DUPLICATE_CASHOUT: TXTWCL_This_bet_has_already_been_Cash_ELL,
  MARKET_SUSPENDED: TXTWCL_One_of_the_markets_in_your_bet_ELL,
  INVALID_BET_DELAY: TXTWCL_SorryX_something_went_wrongX_P_ELL,
  RUNNER_PRICE_CHANGED: TXTWCL_Cash_Out_value_has_changedX_pl_ELL,
  RUNNER_HANDICAP_CHANGED: TXTWCL_The_handicap_line_has_changedX_ELL,
  INVALID_RUNNER: TXTWCL_Cash_Out_Unsuccessful,
  LEG_STATUS_CHANGED: TXTWCL_Something_is_happening_with_yo_ELL,
  ACCESS_DENIED: TXTWCL_Cash_Out_Unsuccessful,
  GENERAL_FAILURE: TXTWCL_Cash_Out_Unsuccessful
};

const getTranslationForResponseStatus = (
  responseStatus: UnsuccessfulCashoutBetResponse['respStatus']
): TranslationTag => responseStatusToTranslationMap[responseStatus];

export default getTranslationForResponseStatus;
